import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Search } from "@mui/icons-material";
import { getGenerationkeysforStciher } from "../../store/keygenreration/action";
import { useNavigate } from "react-router-dom";

const formattedDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const rowsPerPage = 5;

const SticherLicenseTable = () => {
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const { getkeyofsticherlist } = useSelector((state) => state.keygenreration);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const licenses =
    getkeyofsticherlist?.data?.flatMap((client) => {
      const sticher =
        client.SticherLicenses?.map((license) => ({
          ...license,
          type: "Sticher",
          ClientName: client.ClientName,
        })) || [];
      return [...sticher];
    }) || [];

  // ✅ Updated search: match LicenseID or ClientName
  const filteredLicenses = licenses.filter((license) => {
    const search = searchText.toLowerCase();
    return (
      license.LicenseID?.toLowerCase().includes(search) ||
      license.ClientName?.toLowerCase().includes(search)
    );
  });

  const paginatedLicenses = filteredLicenses.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setPage(1);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    dispatch(getGenerationkeysforStciher());
  }, []);

  return (
    <Box
      sx={{
        padding: "20px",
        backgroundColor: "#fff",
        margin: "25px",
        borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <TextField
          placeholder="Search by enterprise or license"
          variant="outlined"
          size="small"
          value={searchText}
          onChange={handleSearchChange}
          sx={{ width: 350 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Client</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>End Users</TableCell>
              <TableCell>Number Of Recordings</TableCell>
              <TableCell>Is Active</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Validity From</TableCell>
              <TableCell>Validity To</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedLicenses.length > 0 ? (
              paginatedLicenses.map((license) => (
                <TableRow
                  key={license.LicenseID}
                  hover
                  onClick={() => navigate(`/key`, { state: { payload: license } })}
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell>{license.ClientName}</TableCell>
                  <TableCell>{license.type}</TableCell>
                  <TableCell>{license?.NumberOfEndUsers || "∞"}</TableCell>
                  <TableCell>{license?.NumberOfRecordings || "∞"}</TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      sx={{
                        color: license.IsActive ? "#15803D" : "#B91C1C",
                        backgroundColor: license.IsActive
                          ? "#F0FDF4"
                          : "#FEF2F2",
                        px: 2,
                        py: 0.5,
                        borderRadius: "16px",
                        width: "50px",
                      }}
                    >
                      {license.IsActive ? "Active" : "Inactive"}
                    </Typography>
                  </TableCell>
                  <TableCell>{formattedDate(license.CreatedAt)}</TableCell>
                  <TableCell>{formattedDate(license.ValidityFrom)}</TableCell>
                  <TableCell>{formattedDate(license.ValidityTo)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No licenses found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Pagination
          count={Math.ceil(filteredLicenses.length / rowsPerPage)}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Box>
  );
};

export default SticherLicenseTable;
